import { array } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { get, keys } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getStringProp, values } from '@mews/fp';
import { LocalizedPropertyObject } from '@mews/framework/localization';

import { ApplicationState } from '../../../types';
import { WithRateId } from '../../../types/selectors/selectorPropTypes';
import { getEntities } from '../getEntities';
import { Entities } from '../types';
import { Rate, Rates } from './types';

const getRates = createSelector<ApplicationState, Entities, Rates>(getEntities, get('rates'));

export const getRateIds = createSelector(getRates, keys);

const getRate = createSelector<ApplicationState, WithRateId, string, Rates | undefined, Rate | undefined>(
    getStringProp('rateId'),
    getRates,
    get
);

export const getRateName = flow<[ApplicationState, WithRateId], Rate | undefined, LocalizedPropertyObject | undefined>(
    getRate,
    get('name')
);

export const getRateRateGroupId = flow<[ApplicationState, WithRateId], Rate | undefined, string | undefined>(
    getRate,
    get('rateGroupId')
);

export const getRateServiceId = flow<[ApplicationState, WithRateId], Rate | undefined, string | undefined>(
    getRate,
    get('serviceId')
);

export const getServiceRateIds = createSelector(getRates, getStringProp('serviceId'), (rates, serviceId) =>
    pipe(
        rates,
        values,
        array.filter((rate) => rate.serviceId === serviceId),
        array.map((rate) => rate.id)
    )
);
